<template>
  <div class="moow-master-container play-background">
    <header-alt></header-alt>

    <div class="total-center">
      <md-empty-state
        md-icon="find_in_page"
        md-label="404"
        md-description="The page you are trying to view was not found."
      >
        <md-button @click="home()" class="md-primary play-cta-button makeup">Take me home</md-button>
      </md-empty-state>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  updated() {},
  methods: {
    home() {
      this.changeView("dashboard");
    },
    changeView(name, params) {
      this.$router.push({
        name: name,
        params: params
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";

h1 {
  font-size: 10em;
}

.total-center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/NotFound.vue